// extracted by mini-css-extract-plugin
export var emptyState = "_5l-d";
export var statCard = "_5l-c";
export var table = "_5l-0";
export var tableCell = "_5l-4";
export var tableCellClickable = "_5l-5 _5l-4";
export var tableCellDefault = "_5l-6 _5l-4";
export var tableCellEmpty = "_5l-8";
export var tableCellWithValue = "_5l-7";
export var tableContainer = "_5l-e";
export var tableHeaderWeight = "_5l-1";
export var tableHeaderZone = "_5l-2";
export var tableRowHeader = "_5l-3";
export var viewModeButton = "_5l-9";
export var viewModeButtonActive = "_5l-a _5l-9";
export var viewModeButtonInactive = "_5l-b _5l-9";